// extracted by mini-css-extract-plugin
module.exports = {"Messages":"ChatMessageArea_Messages__6Se45"};